import { computed, getCurrentInstance, inject, InjectionKey, provide, Ref, ref, watch } from 'vue';

/**
 * @deprecated
 */
export const disabledProps = {
    disabled: {
        type: Boolean,
        default: null,
    },
};

type disabledType = boolean;

type disabledRefType = Ref<disabledType>;

export interface DisabledPropsInterface {
    disabled?: disabledType,
}

const injectionKey: InjectionKey<disabledRefType> = Symbol('disabled');

export function useDisableComposable() {

    type disabledRefType = Ref<disabledType>;

    const disabled: disabledRefType = ref(false);
    const instance = getCurrentInstance();
    if (instance === null) {
        throw new Error('no valid component');
    }
    const props: DisabledPropsInterface = instance.props;

    // erzwingen hier das etwas seltsame Vue Verhalten, dass in defineProps Booleans die nicht gesetzt werden müssen, false und nicht undefined sind
    const propDisabledValue = computed(() => Boolean(props.disabled));

    watch(propDisabledValue, () => {
        disabled.value = propDisabledValue.value;
    }, {
        immediate: true,
    });

    const injectedDisabled = inject(injectionKey, null);
    if (injectedDisabled !== null) {
        watch(injectedDisabled, () => {
            if (propDisabledValue.value === true) {
                return;
            }
            disabled.value = injectedDisabled.value;
        }, {
            immediate: true,
        });
    }
    provide(injectionKey, disabled);

    return {
        disabled,
    };
}
